import store from "../../../store";
import sendpulse_export from './sendpulse_export.vue';

window.sendpulse_export =  new Vue({
    store,
    el: 'div#sendpulse_export',

    name : "sendpulse_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        sendpulse_export,
    }
});
